import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DataTable,
  DataTablePageEvent,
  DataTableRowClickEvent,
} from "primereact/datatable";
import { Column } from "primereact/column";
import {
  formatDateTime,
  parseQueryString,
  toQueryString,
} from "../../common/utils";
import { useUsers } from "../../api/queries/user/useUsers";
import { UserListItem } from "../../api/types/user";
import { none } from "../common";
import { userContext } from "../../context/user";

export default function UserList() {
  const navigate = useNavigate();
  const limit = 20;
  const queryParams = parseQueryString(useLocation().search);
  const { isAdmin } = useContext(userContext);

  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortField, setSortField] = useState(queryParams.sortField);
  const [sortOrder, setSortOrder] = useState(queryParams.sortOrder);

  const onPage = ({ first }: DataTablePageEvent) => setOffset(first);
  const onSort = (event: any) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const { data: users, isLoading } = useUsers(
    {
      limit,
      offset,
    },
    isAdmin(),
  );

  const onRowClick = (event: DataTableRowClickEvent) =>
    navigate(`/users/${event.data.id}`);

  const tFirstName = (row: UserListItem) => row.first_name || none;

  const tLastName = (row: UserListItem) => row.last_name || none;

  const tEmail = (row: UserListItem) => row.email;

  const tCountry = (row: UserListItem) => row.country?.name || none;

  const tIsVerified = (row: UserListItem) => (
    <i className={row.is_verified ? "fa fa-check" : "fa fa-times"} />
  );

  const tCreatedAt = (row: UserListItem) => formatDateTime(row.created_at);

  const tContext = (row: UserListItem) => row.context?.name;

  useEffect(() => {
    const queryParamsStr = toQueryString({
      limit: 20,
      offset,
      sortField,
      sortOrder,
    });
    navigate({ search: queryParamsStr });
  }, [offset, navigate, sortField, sortOrder]);

  useEffect(() => {
    if (users) {
      setTotal(users.data.total_count);
    }
  }, [users]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">User</h1>
      </div>

      <DataTable
        emptyMessage={"No records"}
        paginator={true}
        lazy={true}
        rows={20}
        first={offset}
        totalRecords={total}
        loading={isLoading}
        sortField={sortField}
        sortOrder={sortOrder}
        onPage={onPage}
        onSort={onSort}
        value={users?.data.results || []}
        className="p-datatable-sm p-datatable-pointer"
        onRowClick={onRowClick}
        stripedRows={true}
      >
        <Column header={"First name"} body={tFirstName} />

        <Column header={"Last name"} body={tLastName} />

        <Column header={"E-mail"} body={tEmail} />

        <Column header={"Context"} body={tContext} />

        <Column header={"Country"} body={tCountry} />

        <Column header={"Verified"} body={tIsVerified} />

        <Column header={"Created at"} body={tCreatedAt} />
      </DataTable>
    </div>
  );
}
